import { array, InferType, number, string, object } from 'yup';
import { JobConstants } from '../Types/Job';
import { removeNonDigits } from '../Utils/String';

export const JobPostingModalSchema = object().shape({ 
    title: string().min(1).required(),
    type: string().min(1).required(),
    work_site: string().min(1).required(),
    primary_language: string().min(1).required(),
    pay_amount: object().shape({
        pay_type: string().min(1).required(),
        min: string().min(1).required(),
        max: string().when('pay_type', {
            is: JobConstants.SalaryType.Fixed,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.min(1, 'Required').required('Required').test('is-greater', 'Must be greater than', function (value) {
                const { min } = this.parent;
                const numMin = Number(removeNonDigits(min));
                const numMax = Number(removeNonDigits(value));
                // console.log('numMin: ', numMin);
                // console.log('numMax: ', numMax);
                // console.log('isGreater: ', numMax > numMin);
                return numMax > numMin;
            }),
        }),
    }),
    pay_rate: string().min(1).required(),
    duration: string().when('type', {
        is: 'Internship',
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.notRequired()
    }),
    duration_type: string().when('type', {
        is: 'Internship',
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.notRequired()
    }),
    responsibilities: array().of(string().min(1).required()),
    qualifications: array().of(string().min(1).required()),
    questions: array().of(string().min(1).required()),
    deliverables: array().of(string().min(1).required()),
})

export const TalentPreferenceSchema = object().shape({
    title: string().min(1).required(),
    type: string().min(1).required(),
    work_site: string().min(1).required(),
    primary_language: string().min(1).required(),
    pay_amount: object().shape({
        pay_type: string().min(1).required(),
        min: string().min(1).required(),
        max: string().when('pay_type', {
            is: JobConstants.SalaryType.Fixed,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.min(1, 'Required').required('Required').test('is-greater', 'Must be greater than', function (value) {
                const { min } = this.parent;
                const numMin = Number(removeNonDigits(min));
                const numMax = Number(removeNonDigits(value));
                // console.log('numMin: ', numMin);
                // console.log('numMax: ', numMax);
                // console.log('isGreater: ', numMax > numMin);
                return numMax > numMin;
            }),
        }),
    }),
    pay_rate: string().required(),
    duration: string().when('type', {
        is: JobConstants.JobType.Internship,
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.notRequired()
    }),
    duration_type: string().when('type', {
        is: JobConstants.JobType.Internship,
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.notRequired()
    }),
})

export const EditPostingSchema = object().shape({
    title: string().min(1).required(),
    type: string().min(1).required(),
    work_site: string().min(1).required(),
    primary_language: string().min(1).required(),
    description: string().min(1).required(),
    pay_amount: object().shape({
        pay_type: string().min(1).required(),
        min: string().min(1).required(),
        max: string().when('pay_type', {
            is: JobConstants.SalaryType.Fixed,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.min(1, 'Required').required('Required').test('is-greater', 'Must be greater than', function (value) {
                const { min } = this.parent;
                const numMin = Number(removeNonDigits(min));
                const numMax = Number(removeNonDigits(value));
                // console.log('numMin: ', numMin);
                // console.log('numMax: ', numMax);
                // console.log('isGreater: ', numMax > numMin);
                return numMax > numMin;
            }),
        }),
    }),
    pay_rate: string().required(),
    tags: array().of(string().min(1).required()).required(),
    duration: number().when('type', {
        is: JobConstants.JobType.Internship,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired()
    }),
    duration_type: string().when('type', {
        is: JobConstants.JobType.Internship,
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.notRequired()
    }),
    responsibilities: array().of(string().min(1).required()).required(),
    qualifications: array().of(string().min(1).required()).required(),
    questions: array().of(string().min(1).required()).required(),
    deliverables: array().of(string().min(1).required()).required(),
})
//Types
export type TalentPreferenceType = InferType<typeof TalentPreferenceSchema>;
export type EditPostingType = InferType<typeof EditPostingSchema>;
 
